<template>
  <v-layout>
    <v-data-table
      :headers="headers"
      :items="players"
      hide-default-footer
      class="elevation-1 mx-auto"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">
          {{ props.item.alter }}
        </td>
        <td class="text-xs-right">
          {{ props.item.position }}
        </td>
        <td class="text-xs-right">
          {{ props.item.heimIndex }} ({{ props.item.heimIndex_max }})
        </td>
        <td class="text-xs-right">
          {{ props.item.auswIndex }} ({{ props.item.auswIndex_max }})
        </td>
        <td class="text-xs-right">
          {{ props.item.gehalt | currency }}
        </td>
      </template>
    </v-data-table>
  </v-layout>
</template>
<script>
// show alle players with name, position, vitalvalues, switch view and so on
export default {
  name: 'PlayersTable',
  props: {
    players: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    return {
      headers: [
        {
          text: 'Spieler',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Alter', value: 'alter' },
        { text: 'Position', value: 'position' },
        { text: 'Heimindex (max)', value: 'heimIndex' },
        { text: 'Auswindex (max)', value: 'auswIndex' },
        { text: 'Gehalt', value: 'gehalt' }
      ]
    }
  }
}
</script>
